<tt-page *ngIf="page">
    <tt-card class="col-xs-12 col-md-3 sp-0">
        <tt-input ttLabel="shiftplan_id" [(ttModel)]="page.shiftplan_id" [ttReadonly]="page.is_new === '0'"></tt-input>
        <tt-input ttLabel="shiftplan_description" [(ttModel)]="page.shiftplan_description"></tt-input>
        <tt-button-save ttText="save" [ttLoading]="saving" (ttClick)="saveChanges()"></tt-button-save>
        <tt-button *ngIf="page.is_new === '0'" ttText="delete" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting" (ttClick)="deleteValues()"></tt-button>
    </tt-card>
</tt-page>
